import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { primary, white, whiteFix } from 'presentations/views/styles/color';
import Image from 'presentations/views/components/atoms/Image';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import ServiceSubSectionTitle from 'presentations/views/components/molecules/ServiceSubSectionTitle';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <>
      <SubSectionTitle title={t('title')} icon={'checkbox-marked-outline'} />
      <ListContainer>
        <Container>
          <Title>Step 1</Title>
          <Content>
            <MainIconContainer>
              <MainIcon
                width={97}
                height={80}
                src="pages/features/payment_flow_1.svg"
                alt={t('step 1 title')}
              />
            </MainIconContainer>
            <ContentTitle>{t('step 1 title')}</ContentTitle>
            <ContentDescription>{t('step 1 description')}</ContentDescription>
          </Content>
        </Container>
        <Container>
          <Title>Step 2</Title>
          <Content>
            <MainIconContainer>
              <MainIcon
                width={96}
                height={80}
                src="pages/features/payment_flow_2.svg"
                alt={t('step 2 title')}
              />
            </MainIconContainer>
            <ContentTitle>{t('step 2 title')}</ContentTitle>
            <ContentDescription>{t('step 2 description')}</ContentDescription>
          </Content>
        </Container>
        <Container>
          <Title>Step 3</Title>
          <Content>
            <MainIconContainer>
              <MainIcon
                width={94}
                height={80}
                src="pages/features/payment_flow_3.svg"
                alt={t('step 3 title')}
              />
            </MainIconContainer>
            <ContentTitle>{t('step 3 title')}</ContentTitle>
            <ContentDescription>{t('step 3 description')}</ContentDescription>
          </Content>
        </Container>
      </ListContainer>
    </>
  );
}
const ListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${mediaMax.tablet} {
    display: block;
  }
`;
const Container = styled.div`
  position: relative;
  padding-top: 25px;
  width: 32%;
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(20)};
  }
`;
const Title = styled.div`
  background-color: ${primary};
  color: ${whiteFix};
  position: absolute;
  top: 0;
  left: calc(50% - 70px);
  width: 140px;
  height: 50px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${fontWeight('bold')};
`;
const Content = styled.div`
  background-color: ${white};
  border-radius: ${borderRadius(16)};
  box-shadow: 0px 10px 30px rgba(102, 102, 102, 0.15);
  padding: ${spacing(32)};
  height: 100%;
`;
const ContentTitle = styled.div`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  text-align: center;
  margin-bottom: ${spacing(12)};
`;
const ContentDescription = styled.p``;

const SubSectionTitle = styled(ServiceSubSectionTitle)`
  margin-bottom: ${spacing(64)};
`;
const MainIconContainer = styled.div`
  text-align: center;
  margin-bottom: ${spacing(32)};
  margin-top: ${spacing(12)};
`;
const MainIcon = styled(Image)``;
